module.exports = __webpack_public_path__ + "static/media/group_26@2x.9898e9d6.png";